import { c as _c } from "react/compiler-runtime";
import { useMemo } from "react";
import { getMarkupStatusValue } from "@pages/project-details/project-markups/status/markup-status-utils";
import { ChipStatus } from "@flat-ui";

/** Renders the status of a project markup as a chip */
export function MarkupStatus(t0) {
  const $ = _c(4);
  const {
    markup
  } = t0;
  const status = markup.status?.value;
  let t1;
  if ($[0] !== status) {
    t1 = getMarkupStatusValue(status);
    $[0] = status;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const annotationStatus = t1;
  let t2;
  if ($[2] !== annotationStatus) {
    t2 = <ChipStatus status={annotationStatus} size="small" />;
    $[2] = annotationStatus;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}